export default __webpack_public_path__ + "static/media/newfood.daeb9d65.svg";